import { log } from 'log';
import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';
import { resetToDefault } from 'js/hooks/user/store/actions';

import * as pas from '../pas';
import * as server from '../server';
import * as actions from '../store/actions';

export const useLogout = () => {
    const dispatch = useDispatch();
    const windowSessionId = useUserSelector(prop('windowSessionId'));

    return useCallback((isQuiet, isSkipLogoutInProcess) => {
        !isSkipLogoutInProcess && dispatch(actions.setIsLogoutInProcess(true));
        dispatch(resetToDefault());

        (async () => {
            try {
                await pas.setLoginType(null);

                if (isQuiet) {
                    await pas.logout();
                } else {
                    await server.endWindowSession(windowSessionId);
                    await server.logout();
                }
            } catch (err) {
                log('info', err);
            } finally {
                !isSkipLogoutInProcess && dispatch(actions.setIsLogoutInProcess(false));
            }
        })();
    }, [windowSessionId, dispatch]);
};
